import PlatinumCase from '@/assets/cases/platinum.svg';
import TitaniumCase from '@/assets/cases/titanium.svg';
import WhiteGoldCase from '@/assets/cases/white-gold.svg';

export const CASE_SVG_MAPPING: Record<string, string> = {
  TITNM: TitaniumCase, // Titanium
  '18KWHGL': WhiteGoldCase, // 18k white gold
  PLTNM: PlatinumCase, // Platinum
};

export const CASE_COLOR_MAPPING: Record<string, string> = {
  STSTL:
    'linear-gradient(137.96deg, #747474 -9.54%, #FCFCFC 50.22%, #757575 96.28%)', // Stainless steel
  STNSTL_18KREG:
    'linear-gradient(140.19deg, #9B9B9B 12.43%, #FFFFFF 41.4%, #FDFDFD 46.72%, #B3886C 46.91%, rgba(251, 236, 221, 0.99) 53.23%, #B08467 69.38%, #58382E 85.68%)', // Stainless steel & 18k red gold
  '18KREG':
    'linear-gradient(143.88deg, #8F5F41 15.14%, rgba(194, 157, 132, 0.997558) 33.25%, rgba(251, 236, 221, 0.99) 50.2%, #B08467 73.53%, #58382E 82.07%)', // 18k red gold
  BREITL:
    'linear-gradient(142.88deg, #252525 15.8%, #616161 34.93%, #858585 49.82%, #515151 64.48%, #181818 78.71%)', // Breitlight®
  DLC_CTI:
    'linear-gradient(141.17deg, #232323 15.51%, #A9A9A9 48.18%, #2D2D2D 88.43%)', // DLC-coated titanium
  STNSTL_18KROG:
    'linear-gradient(140.19deg, #9B9B9B 13.76%, #FFFFFF 43.14%, #FDFDFD 46.72%, #D38F6A 46.91%, #FFFBF4 53.23%, #D69E7D 80.79%)', // Stainless steel & 18k rose gold
  SS_TNG:
    'linear-gradient(140.19deg, #9B9B9B 11.89%, #FFFFFF 43.9%, #FDFDFD 46.72%, #626468 46.91%, #B4BCBD 53.23%, #303334 80.79%)', // Stainless steel & tungsten
  CERAM_GEM: '#efefef', // Ceramic
  DLCCSSTL:
    'linear-gradient(141.17deg, #232323 15.51%, #9B9B9B 48.18%, #2D2D2D 88.43%)', // DLC-coated stainless steel
  BETTERGOLD:
    'linear-gradient(145.71deg, #8F5F41 13.58%, rgba(194, 157, 132, 0.997558) 25.23%, rgba(251, 236, 221, 0.99) 49.91%, #B08467 78.8%, #855F4B 86.78%, #58382E 99.5%)', // Small scale traceable 18K red gold
  SS_PLAT:
    'linear-gradient(140.19deg, #9B9B9B 16.58%, #FFFFFF 45.14%, #FDFDFD 46.72%, #CECECE 46.91%, #F1F1F1 51.25%, #ABADB1 79.25%)', // Stainless steel & platinum
  STNSTL_GEM:
    'linear-gradient(137.96deg, #747474 -9.54%, #FCFCFC 50.22%, #757575 96.28%)', // Stainless steel (gem-set)
  STNSTL_18KREG_GEM:
    'linear-gradient(140.19deg, #9B9B9B 12.43%, #FFFFFF 41.4%, #FDFDFD 46.72%, #B3886C 46.91%, rgba(251, 236, 221, 0.99) 53.23%, #B08467 69.38%, #58382E 85.68%)', // Stainless steel & 18k red gold (gem-set)
  BRNZ: 'linear-gradient(318.58deg, #6C3C04 13.35%, #F8CF96 50.92%, #AC8651 77.26%)', // Bronze
  '18KYEGLD':
    'linear-gradient(144.66deg, #AF8230 7.78%, #FCF1AB 48.96%, #D1B467 76%, #FCF1AB 95.41%, #C39F50 108.53%)', // 18k yellow gold
  '18KYELGLD_GEM':
    'linear-gradient(143.88deg, #8F5F41 15.14%, rgba(194, 157, 132, 0.997558) 33.25%, rgba(251, 236, 221, 0.99) 50.2%, #B08467 73.53%, #58382E 82.07%)', // 18k red gold (gem-set)
  SS_18KGRG_GEM:
    'linear-gradient(137.96deg, #747474 -9.54%, #FCFCFC 50.22%, #757575 96.28%)', // Stainless steel & 18k grey gold (gem-set)
  SS_18KWHGLD:
    'linear-gradient(137.96deg, #747474 -9.54%, #FCFCFC 50.22%, #EAEAEA 96.28%)', // Stainless steel & 18k white gold
  // '18k rose gold':
  //   'linear-gradient(145.49deg, #BC744C 6.81%, #F4B494 25.57%, #FFFBF5 50.75%, #F4B494 71.65%, #AC7E5C 90.59%)',
  // 'Two Tone':
  //   'linear-gradient(140.19deg, #9B9B9B 12.43%, #FFFFFF 41.4%, #FDFDFD 46.72%, #B3886C 46.91%, rgba(251, 236, 221, 0.99) 53.23%, #B08467 69.38%, #58382E 85.68%)',
};

export const DIAL_COLOR_MAPPING: Record<string, string> = {
  'V-DIAL-COLOR-5664': 'linear-gradient(210deg, #576269 0%, #282c2f 100%)', // Anthracite
  'V-DIAL-COLOR-AQUA': 'linear-gradient(210deg, #88B7CB, #7EA9BC)', // Aquamarine
  'V-DIAL-COLOR-5969': 'linear-gradient(210deg, #D9B589, #D19B67)', // Beige
  'V-DIAL-COLOR-5714': 'linear-gradient(210deg, #3B82B2 0%, #256795 100%)', // Blue
  'V-DIAL-COLOR-5716': 'linear-gradient(210deg, #D6E5E7, #9AC7C8)', // Blue mother-of-pearl
  'V-DIAL-COLOR-5686': 'linear-gradient(211deg, #111820 0%, #363636 100%)', // Black
  'V-DIAL-COLOR-5687': 'linear-gradient(210deg, #4F4F4F, #2A2A2A)', // Black mother-of-pearl
  'V-DIAL-COLOR-5720': 'linear-gradient(210deg, #5A4541 0%, #150300 100%)', // Bronze
  'V-DIAL-COLOR-5723': 'linear-gradient(210deg, #745400 0%, #7B4200 100%)', // Brown
  'V-DIAL-COLOR-9696': 'linear-gradient(210deg, #541D2D, #380411)', // Burgundy
  'V-DIAL-COLOR-CHAMP': 'linear-gradient(225deg, #E4B978 0%, #A7813E 100%)', // Champagne
  'V-DIAL-COLOR-5765556362':
    'linear-gradient(210deg, #2F2F2F 0%, #070707 100%)', // Carbon
  'V-DIAL-COLOR-5842': 'linear-gradient(225deg, #EFC89E 0%, #D2AF96 100%)', // Cream
  'V-DIAL-COLO-999': 'linear-gradient(225deg, #D9971C 0%, #B47F1B 100%)', // Copper
  'V-DIAL-COLOR-44555162': 'linear-gradient(210deg, #BBBAB5 0%, #BEBFB9 100%)', // Dove grey
  'V-DIAL-COLOR-5765': 'linear-gradient(210deg, #3BB252 0%, #259532 100%)', // Green
  'V-DIAL-COLOR-1111': 'linear-gradient(210deg, #B4CAD1, #859DA5)', // Ice blue
  'V-DIAL-COLOR-LATTE': 'linear-gradient(210deg, #DBD3CA, #C1B096)', // Iced latte
  'V-DIAL-COLOR-445566': 'linear-gradient(210deg, #233E63, #000A28)', // Midnight blue
  'V-DIAL-COLOR-8888': 'linear-gradient(210deg, #AFBE9F, #8B987B)', // Mint green
  'V-DIAL-COLOR-5791': 'linear-gradient(210deg, #FBF6F2, #EBE8E3)', // Mother-of-pearl
  'V-DIAL-CLOR-MUS': 'linear-gradient(210deg, #D58600 0%, #A85900 100%)', // Mustard
  'V-DIAL-COLOR-5800': 'linear-gradient(210deg, #FF8900 0%, #985200 100%)', // Orange
  'V-DIAL-COLOR-7777': 'linear-gradient(210deg, #F7B9AD 0%, #C67C70 100%)', // Pink
  'V-DIAL-COLOR-6666': 'linear-gradient(210deg, #E0C7C6 0%, #CA9492 100%)', // Pink mother-of-pearl
  'V-DIAL-COLOR-66477271': 'linear-gradient(210deg, #62C2B4 0%, #009D80 100%)', // Peppermint
  'V-DIAL-COLOR-443322': 'linear-gradient(210deg, #B1C48C 0%, #8E9F6B 100%)', // Pistachio green
  'V-DIAL-COLOR-556644': 'linear-gradient(210deg, #B23B3B 0%, #6d2222 100%)', // Red
  'V-DIAL-COLOR-6366444211': 'linear-gradient(210deg, #AC8C70, #B38A5F)', // Sand
  'V-DIAL-COLOR-5843': 'silver', // Silver
  VDIALCOLOR9999: 'linear-gradient(210deg, #FFC400 0%, #FFC400 100%)', // Yellow
  'V-DIAL-COLOR-9876': 'linear-gradient(210deg, #009AAA, #008EA4)', // Turquoise
  'V-DIAL-WALNUT': 'linear-gradient(217deg, #674636 0%, #341D0C 100%)', // Walnut burl
  'V-DIAL-COLOR-5926': 'linear-gradient(217deg, #FFFFFF 0%, #EFEFEF 100%)', // White
};

export const STRAP_COLOR_MAPPING: Record<string, string> = {
  'V-STRAP-COLOR-5664': 'linear-gradient(210deg, #576269 0%, #282c2f 100%)', // Anthracite
  'V-STRAP-COLOR-AQUA': 'linear-gradient(210deg, #88B7CB, #7EA9BC)', // Aquamarine
  V_STRAP_COLOR_BEIGE: 'linear-gradient(210deg, #D9B589, #D19B67)', // Beige
  'V-STRAP-COLOR-5714': 'linear-gradient(210deg, #3B82B2 0%, #256795 100%)', // Blue
  'V-STRAP-COLOR-5686': 'linear-gradient(211deg, #111820 0%, #363636 100%)', // Black
  'V-STRAP-COLOR-5723': 'linear-gradient(210deg, #745400 0%, #7B4200 100%)', // Brown
  V_STRAP_COLOR_BURG: 'linear-gradient(210deg, #541D2D, #380411)', // Burgundy
  'V-STRAP-COLOR-G18': 'linear-gradient(210deg, #FF5733 0%, #a63921 100%)', // Gold brown
  'V-STRAP-COLOR-5765': 'linear-gradient(210deg, #3BB252 0%, #259532 100%)', // Green
  // 'Ice latte': 'linear-gradient(210deg, #DBD3CA, #C1B096)',
  'V-STRAP-COLOR-LATTE': 'linear-gradient(210deg, #DBD3CA, #C1B096)', // Iced latte
  'V-STRAP-COLOR-5779': 'linear-gradient(210deg, #8A865D 0%, #4a4831 100%)', // Khaki green
  'V-STRAP-COLOR-6666': 'silver', // Metal bracelet
  'V-STRAP-COLOR-MINT': 'linear-gradient(210deg, #AFBE9F, #8B987B)', // Mint green
  'V-STRAP-COLOR-5800': 'linear-gradient(210deg, #FF8900 0%, #985200 100%)', // Orange
  V_STRAP_COLOR_PINK: 'linear-gradient(210deg, #F7B9AD 0%, #C67C70 100%)', // Pink
  V_STRAP_COLOR_RED: 'linear-gradient(210deg, #B23B3B 0%, #6d2222 100%)', // Red
  VSTRAPCOLOR5929: 'linear-gradient(210deg, #AC8C70, #B38A5F)', // Sand
  V_STRAP_COLOR_YELLOW: 'linear-gradient(210deg, #FFC400 0%, #FFC400 100%)', // Yellow
  'V-SRAP-COLOR-TANGERINE': 'linear-gradient(210deg, #F96812, #EB5A08)', // Tangerine
  'V-STRAP-COLOR-9876': 'linear-gradient(210deg, #009AAA, #008EA4)', // Turquoise
  'V-STRAP-COLOR-5926': 'linear-gradient(217deg, #FFFFFF 0%, #EFEFEF 100%)', // White
};

export const FRAME_COLOR_MAPPING: Record<string, string> = {
  'Silver & black':
    'repeating-linear-gradient(210deg, #A9A9A9 0%, #A9A9A9 10%, #2D2D2D 10%, #2D2D2D 20%)',
  'Dark grey': 'linear-gradient(210deg, #2D2D2D 0%, #1A1A1A 100%)',
  Havana: 'linear-gradient(210deg, #A0522D 0%, #7B4B3A 100%)',
  SLBLK: 'linear-gradient(210deg, #A9A9A9 0%, #2D2D2D 100%)',
};

export const LENS_COLOR_MAPPING: Record<string, string> = {
  'MER_LENS_COLOUR-BLUE': 'linear-gradient(210deg, #3B82B2 0%, #256795 100%)',
  'MER_LENS_COLOUR-GRBL': 'linear-gradient(210deg, #A3C9E2 0%, #3B82B2 100%)',
  'MER_LENS_COLOUR-GREEN': 'linear-gradient(210deg, #5C6E5D 0%, #3F4D43 100%)',
  GREY: 'linear-gradient(210deg, #A0A0A0 0%, #6B6B6B 100%)',
  'MER_LENS_COLOUR-GRADIENTGREY':
    'linear-gradient(210deg, #D1D1D1 0%, #6B6B6B 100%)',
  'GREEN LIGHT PRO': 'linear-gradient(210deg, #C3D4A3 0%, #8FA37B 100%)',
  'MER_LENS_COLOUR-GRADIENTGREEN':
    'linear-gradient(210deg, #8FA37B 0%, #3E4B3D 100%)',
  'MER_LENS_COLOUR-GRDRBL': 'linear-gradient(210deg, #2C4A72 0%, #1A2E4F 100%)',
  'V-DIAL-COLOR-5714': 'linear-gradient(210deg, #3B82B2 0%, #256795 100%)', // Blue
  GRDRBL: 'linear-gradient(210deg, #A3C9E2 0%, #3B82B2 100%)', // Gradient blue
  GRGRN: 'linear-gradient(210deg, #5C6E5D 0%, #3F4D43 100%)', // Gradient green
  'ENS_COLOUR-GREENZEISSLIGHTPRO':
    'linear-gradient(210deg, #D0E0D0 0%, #A8C0A8 100%)',
  'MER_LENS_COLOUR-DARKGREY':
    'linear-gradient(210deg, #6E6E6E 0%, #404040 100%)',
  'MER_LENS_COLOUR-GRGRPNK':
    'linear-gradient(210deg, #A8A8A8 0%, #F2C6CF 100%)',
};
